var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ppv2-flex ppv2-items-center ppv2-justify-between ppv2-px-5 ppv2-pt-4 ppv2-pb-3"},[_c('PreviewLabel'),_vm._v(" "),_c('LiveBadge')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }